import { faTimes } from "@jewlr/pro-regular-svg-icons/faTimes"
import {
  Box,
  Button,
  Flex,
  FontAwesomeIcon,
  Image,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import Modal, { closeModal } from "components/modal"

const PreviewImageModal = ({ previewImage }) => {
  if (!previewImage) return null

  return (
    <Modal
      contentStyle={{ pb: 2, pt: 0, px: 2 }}
      headerHTML={
        <Flex
          alignItems="center"
          justifyContent="space-between"
          mb="4px"
          pt={2}
          px={2}
        >
          <Typography fontWeight="600" variant="body-sm">
            Preview Design
          </Typography>
          <Button
            aria-label="Close"
            onClick={() => closeModal()}
            p="4px"
            variant="text"
          >
            <FontAwesomeIcon
              color="blackPrint"
              fontSize="18px"
              icon={faTimes}
            />
          </Button>
        </Flex>
      }
      height="fit-content"
      modalType="popup"
      show="#preview"
      width="100%"
    >
      <Box textAlign="center">
        <Image
          alt=""
          mx="auto"
          ratio="1 / 1"
          sizes="100vw"
          src={previewImage.src}
          srcSet={previewImage.srcSet}
          width="100%"
        />
      </Box>
    </Modal>
  )
}

PreviewImageModal.propTypes = {
  previewImage: PropTypes.object,
}

const mapStateToProps = (state) => {
  const allViews = state.previewImage.data?.all_views || []
  const slides = state.previewImage.data?.images || []
  const previewSlide = Object.entries(slides).find(([view]) =>
    allViews.includes(view.replace("_view", ""))
  )

  return {
    previewImage: previewSlide ? previewSlide[1] : null,
  }
}

export default connect(mapStateToProps)(PreviewImageModal)
